module.exports = __webpack_public_path__ + "img/logo.5855ef22.svg";